// File: /src/components/Sidebar.js

import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import LogoutButton from './LogoutButton';
import '../styles/Sidebar.css';

function NavMenu() {
	const [menuOpen, setMenuOpen] = useState(false);
	const location = useLocation();

	// Toggle menu visibility
	const toggleMenu = () => {
		setMenuOpen((prevState) => !prevState);
	};

	// Close menu when clicking outside
	const closeMenuOnOutsideClick = (event) => {
		if (
			!event.target.closest('.drawer-content') &&
			!event.target.closest('.menu-button')
		) {
			setMenuOpen(false);
		}
	};

	// Close menu after clicking a menu item
	const handleMenuClick = () => {
		setMenuOpen(false);
	};

	// Add event listener for outside clicks
	useEffect(() => {
		document.addEventListener('click', closeMenuOnOutsideClick);
		return () => {
			document.removeEventListener('click', closeMenuOnOutsideClick);
		};
	}, []);

	// Close sidebar on route change
	useEffect(() => {
		setMenuOpen(false);
	}, [location.pathname]);

	return (
		<>
			{/* Menu hamburger icon */}
			<button
				className={`menu-button ${
					menuOpen ? 'menu-button-active' : ''
				}`}
				onClick={toggleMenu}
				aria-label="Toggle menu"
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				>
					<line x1="3" y1="12" x2="21" y2="12"></line>
					<line x1="3" y1="6" x2="21" y2="6"></line>
					<line x1="3" y1="18" x2="21" y2="18"></line>
				</svg>
			</button>

			{/* Sidebar drawer */}
			<div className={`sidebar-drawer ${menuOpen ? 'open' : ''}`}>
				<div className="drawer-content">
					<ul className="main-menu">
						<li className="sidebar-item">
							<Link
								to="/"
								className={`sidebar-link ${
									location.pathname === '/' ? 'active' : ''
								}`}
								onClick={handleMenuClick}
							>
								<span className="sidebar-icon">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="20"
										height="20"
										viewBox="0 0 24 24"
										fill="none"
										stroke="currentColor"
										strokeWidth="2"
										strokeLinecap="round"
										strokeLinejoin="round"
									>
										<rect
											x="3"
											y="3"
											width="7"
											height="7"
										></rect>
										<rect
											x="14"
											y="3"
											width="7"
											height="7"
										></rect>
										<rect
											x="14"
											y="14"
											width="7"
											height="7"
										></rect>
										<rect
											x="3"
											y="14"
											width="7"
											height="7"
										></rect>
									</svg>
								</span>
								<span>Dashboard</span>
							</Link>
						</li>
						<li className="sidebar-item">
							<Link
								to="/grid-clients"
								className={`sidebar-link ${
									location.pathname.includes('/grid-clients')
										? 'active'
										: ''
								}`}
								onClick={handleMenuClick}
							>
								<span className="sidebar-icon">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="20"
										height="20"
										viewBox="0 0 24 24"
										fill="none"
										stroke="currentColor"
										strokeWidth="2"
										strokeLinecap="round"
										strokeLinejoin="round"
									>
										<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
										<circle cx="9" cy="7" r="4"></circle>
										<path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
										<path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
									</svg>
								</span>
								<span>Clientes</span>
							</Link>
						</li>
						<li className="sidebar-item">
							<Link
								to="/finance"
								className={`sidebar-link ${
									location.pathname.includes('/finance')
										? 'active'
										: ''
								}`}
								onClick={handleMenuClick}
							>
								<span className="sidebar-icon">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="20"
										height="20"
										viewBox="0 0 24 24"
										fill="none"
										stroke="currentColor"
										strokeWidth="2"
										strokeLinecap="round"
										strokeLinejoin="round"
									>
										<line
											x1="12"
											y1="1"
											x2="12"
											y2="23"
										></line>
										<path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
									</svg>
								</span>
								<span>Financeiro</span>
							</Link>
						</li>
						<li className="sidebar-item">
							<Link
								to="/kanban"
								className={`sidebar-link ${
									location.pathname.includes('/kanban')
										? 'active'
										: ''
								}`}
								onClick={handleMenuClick}
							>
								<span className="sidebar-icon">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="20"
										height="20"
										viewBox="0 0 24 24"
										fill="none"
										stroke="currentColor"
										strokeWidth="2"
										strokeLinecap="round"
										strokeLinejoin="round"
									>
										<rect x="3" y="3" width="7" height="18" rx="1"></rect>
										<rect x="14" y="3" width="7" height="14" rx="1"></rect>
									</svg>
								</span>
								<span>Kanban</span>
							</Link>
						</li>
						<li className="sidebar-item">
							<Link
								to="/calendar"
								className={`sidebar-link ${
									location.pathname.includes('/calendar')
										? 'active'
										: ''
								}`}
								onClick={handleMenuClick}
							>
								<span className="sidebar-icon">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="20"
										height="20"
										viewBox="0 0 24 24"
										fill="none"
										stroke="currentColor"
										strokeWidth="2"
										strokeLinecap="round"
										strokeLinejoin="round"
									>
										<rect
											x="3"
											y="4"
											width="18"
											height="18"
											rx="2"
											ry="2"
										></rect>
										<line
											x1="16"
											y1="2"
											x2="16"
											y2="6"
										></line>
										<line
											x1="8"
											y1="2"
											x2="8"
											y2="6"
										></line>
										<line
											x1="3"
											y1="10"
											x2="21"
											y2="10"
										></line>
									</svg>
								</span>
								<span>Calendário</span>
							</Link>
						</li>
					</ul>

					<div className="bottom-menu">
						<div className="sidebar-divider"></div>
						<li className="sidebar-item">
							<Link
								to="/user-account"
								className={`sidebar-link ${
									location.pathname.includes('/user-account')
										? 'active'
										: ''
								}`}
								onClick={handleMenuClick}
							>
								<span className="sidebar-icon">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="20"
										height="20"
										viewBox="0 0 24 24"
										fill="none"
										stroke="currentColor"
										strokeWidth="2"
										strokeLinecap="round"
										strokeLinejoin="round"
									>
										<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
										<circle cx="12" cy="7" r="4"></circle>
									</svg>
								</span>
								<span>Minha Conta</span>
							</Link>
						</li>
						<li className="sidebar-item logout-item">
							<LogoutButton />
						</li>
						<div className="sidebar-footer">
							<p>© {new Date().getFullYear()} LocaTime</p>
							<div className="deeplynx-container">
								<span className="developed-by">Powered by:</span>
								<a 
									href="https://www.deeplynx.com.br/pt/" 
									target="_blank" 
									rel="noopener noreferrer"
									className="deeplynx-link"
								>
									<img 
										src="/deeplynx.png" 
										alt="DeepLynx" 
										className="deeplynx-logo"
									/>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			{menuOpen && (
				<div className="sidebar-backdrop" onClick={toggleMenu}></div>
			)}
		</>
	);
}

export default NavMenu;
